export default {
  GET_SALES_TRACKING: "GET_SALES_TRACKING",
  GET_SALES_TRACKING_BY_SELLER: "GET_SALES_TRACKING_BY_SELLER",
  UPDATE_COMPROMISES_BY_SELLER: "UPDATE_COMPROMISES_BY_SELLER"
};
